export const W2_TEACHING_VERSION = 2;
export const countChineseCharacters = value => [...String(value || '')].filter(c => /\p{Script=Han}/u.test(c)).length;
export function isShortChineseSentence(value) {
 const count=countChineseCharacters(value);
 return typeof value==='string' && count>=7 && count<=10 && /^[\p{Script=Han}\p{P}\s]+$/u.test(value);
}
export const W2_CHOICE_LABELS = {S:'Pilihan subjek',V:'Pilihan kata kerja',Adj:'Pilihan kata sifat'};
